import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: "app-info",
    templateUrl: "./info.component.html",
    styleUrls: ["./info.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoComponent implements OnInit {
  infoMessage: string = '';
  constructor(readonly route: ActivatedRoute){
    // This is intended.
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const reason = params['reason'];
      if (reason === 'empty') {
        this.infoMessage =
          'No resources shown. All Medications have internal Substance resources.';
      } else {
        this.infoMessage =
          'Selected collection does not have any data to display.';
      }
    });
  }
}
